import React from "react";
import './Home.css';
import { Link } from "react-router-dom";
import GridOnIcon from '@mui/icons-material/GridOn';
import Search from "../components/Search.js";
import { Avatar, IconButton } from '@mui/material';


function Home(){
    return (
        <div className="home">
            <div className="home__header">
                <div className="home__header--left">
                    <Link to='/about' className="nav__link">About</Link>
                    <Link to='/store' className="nav__link">Store</Link>
                </div>

                <div className="home__header--right">
                <Link to='/gmail' className="nav__link">Gmail</Link>
                <Link to='/images' className="nav__link">Images</Link>
                <div className="nav__link icons">
                    <GridOnIcon />
                </div>
                <Avatar/>
                </div>

            </div>
            <div className="home__body">
                <img src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png" 
                alt="" className="google__img" />
                <div className="home__input--container">
                     <Search />
                </div>
            </div>

        </div>
    )
}

export default Home